<template>
  <div>
    <b-row>
      <b-col cols="8 mb-2"></b-col>

      <b-col cols="4">
        <b-dropdown
          text="Opciones"
          class="btn b-dropdown text-right"
          variant="success"
        >
          <b-dropdown-item v-if="isAdmin">
            <downloadExcel
              :data="filteredItems()"
              worksheet="Gestiones"
              name="Gestiones.xls"
              :fields="json_fields"
              :before-generate="startDownload"
              :before-finish="finishDownload"
              >Exportar</downloadExcel
            >
          </b-dropdown-item>
        </b-dropdown>
      </b-col>

      <h5 class="col-sm-12">Filtrar por</h5>

      <b-col sm="2">
        <b-form-group>
          <label class="mb-0" for="txtFechaDesde">Fecha desde</label>
          <b-form-input
            type="date"
            id="txtFechaDesde"
            v-model="range.startDate"
            :max="range.endDate == '' ? maxDate : range.endDate"
            @blur="changeDate()"
          ></b-form-input>
        </b-form-group>
      </b-col>
      <b-col sm="2">
        <b-form-group>
          <label class="mb-0" for="txtFechaHasta">Fecha hasta</label>
          <b-form-input
            type="date"
            id="txtFechaHasta"
            v-model="range.endDate"
            :min="range.startDate"
            :max="maxDate"
            @blur="changeDate()"
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col v-if="role_id == 1 || role_id == 8">
        <b-form-group>
          <label class="mb-0">Prejurídico</label>
          <b-form-select v-model="staff_idFilter" @change="getData()">
            <template slot="first">
              <option :value="null">-- Todos--</option>
            </template>
            <option v-for="item in lstStaffs" :key="item.id" :value="item.id">
              {{ item.name }} {{ item.last_name }} ({{ item.type_name }})
            </option>
          </b-form-select>
        </b-form-group>
      </b-col>
      <br />
      <br />
      <b-col cols="12" xl="12">
        <transition name="slide">
          <b-card :header="caption">
            <b-table
              sticky-header
              :hover="hover"
              :striped="striped"
              :bordered="bordered"
              :small="small"
              :fixed="fixed"
              responsive
              :items="filteredItems()"
              :fields="fields"
              foot-clone
              :current-page="currentPage"
              :sort-compare="sortDate"
              :sort-by="'date_management'"
              :sort-desc="false"
            >
              <template slot="total_call" slot-scope="data">
                <a
                  v-if="data.item.total_call > 0"
                  href="javascript:void(0)"
                  @click="showDetail(data.item, 'total_call')"
                  >{{ data.item.total_call }}</a
                >
                <span v-else>{{ data.item.total_call }}</span>
              </template>

              <template slot="total_letter" slot-scope="data">
                <a
                  v-if="data.item.total_letter > 0"
                  href="javascript:void(0)"
                  @click="showDetail(data.item, 'total_letter')"
                  >{{ data.item.total_letter }}</a
                >
                <span v-else>{{ data.item.total_letter }}</span>
              </template>

              <template slot="total_email" slot-scope="data">
                <a
                  v-if="data.item.total_email > 0"
                  href="javascript:void(0)"
                  @click="showDetail(data.item, 'total_email')"
                  >{{ data.item.total_email }}</a
                >
                <span v-else>{{ data.item.total_email }}</span>
              </template>

              <template slot="total_observation" slot-scope="data">
                <a
                  v-if="data.item.total_observation > 0"
                  href="javascript:void(0)"
                  @click="showDetail(data.item, 'total_observation')"
                  >{{ data.item.total_observation }}</a
                >
                <span v-else>{{ data.item.total_observation }}</span>
              </template>

              <template slot="total_whatsapp" slot-scope="data">
                <a
                  v-if="data.item.total_whatsapp > 0"
                  href="javascript:void(0)"
                  @click="showDetail(data.item, 'total_whatsapp')"
                  >{{ data.item.total_whatsapp }}</a
                >
                <span v-else>{{ data.item.total_whatsapp }}</span>
              </template>

              <template slot="total_message" slot-scope="data">
                <a
                  v-if="data.item.total_message > 0"
                  href="javascript:void(0)"
                  @click="showDetail(data.item, 'total_message')"
                  >{{ data.item.total_message }}</a
                >
                <span v-else>{{ data.item.total_message }}</span>
              </template>

              <!-- A custom formatted footer -->
              <template slot="FOOT_date_management">
                <span class="text-success">TOTALES</span>
              </template>

              <template slot="FOOT_total_call">
                <strong>{{ totalCall() }}</strong>
              </template>

              <template slot="FOOT_total_letter">
                <strong>{{ totalLetter() }}</strong>
              </template>

              <template slot="FOOT_total_email">
                <strong>{{ totalEmail() }}</strong>
              </template>

              <template slot="FOOT_total_observation">
                <strong>{{ totalObservation() }}</strong>
              </template>

              <template slot="FOOT_total_whatsapp">
                <strong>{{ totalWhatsapp() }}</strong>
              </template>

              <template slot="FOOT_total_message">
                <strong>{{ totalMessage() }}</strong>
              </template>

              <template slot="FOOT_hour">
                <strong>{{ totalHour() }}</strong>
              </template>
            </b-table>
          </b-card>
        </transition>
      </b-col>
    </b-row>
    <!-- MODAL PARA EL COMPONENTE DE CREAR ACTIVIDADES O TASK -->
    <div class="modal fade" id="dlgDetail">
      <div class="modal-dialog modal-dialog-centered modal-success modal-lg">
        <div class="modal-content">
          <!-- Modal Header -->
          <div class="modal-header">
            <h4 class="modal-title">DETALLE DE {{ title }}</h4>
            <button type="button" class="close" @click="closeDetail()">
              &times;
            </button>
          </div>
          <!-- Modal body -->
          <div class="modal-body">
            <div class="b-table-sticky-header font-size-12">
              <b-table
                :bordered="true"
                sticky-header
                striped
                :items="details"
                :fields="fields_details"
              >
                <template slot="minutes" slot-scope="data">
                  <span>{{ data.item.minutes }} min</span>
                </template>

                <template slot="actions" slot-scope="data" class="text-center">
                  <b-button
                    size="sm"
                    variant="primary"
                    class="mr-1 btn-custom-size"
                    @click="viewDebtor(data.item.debtor_id)"
                    title="Ver deudor"
                  >
                    <i class="fa fa-eye"></i>
                  </b-button>
                </template>
              </b-table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- FIN MODAL PARA EL COMPONENTE DE CREAR ACTIVIDADES O TASK -->
  </div>
</template>

<script>
import DateRangePicker from "vue2-daterange-picker"; //https://github.com/Innologica/vue2-daterange-picker/blob/master/src/components/DateRangePicker.vue
import moment from "moment";
export default {
  name: "debtormanagementanalysis",
  components: { DateRangePicker },
  props: {
    caption: {
      type: String,
      default: "GESTIONES",
    },
    hover: {
      type: Boolean,
      default: true,
    },
    striped: {
      type: Boolean,
      default: true,
    },
    bordered: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: true,
    },
    fixed: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return {
      role_id: localStorage.getItem("role_id"), // PARA DETERMINAR EL ROL DEL USUARIO QUE INGRESA
      maxDate: moment(String(new Date())).format("YYYY-MM-DD"),
      range: {
        startDate: moment(String(sumarDias(new Date(), -30))).format(
          "YYYY-MM-DD"
        ),
        endDate: moment(String(new Date())).format("YYYY-MM-DD"),
      },
      tableData: [],
      tableHeader: [],
      token: localStorage.getItem("token"),
      auth: localStorage.getItem("auth"),
      isAdmin: localStorage.getItem("auth_is_admin") === "S" ? true : false,
      selectAll: false,
      status: null,
      staff_id: null,
      customer_id: null,
      customer_name: null,
      fields: [
        {
          key: "date_management",
          name: "Fecha",
          label: "Fecha",
          sortable: true,
        },
        {
          key: "total_call",
          name: "Llamada Inicial",
          label: "Llamada",
          sortable: true,
        },
        // {
        //   key: "initial_call",
        //   name: "Llamada Inicial",
        //   label: "Llamada Inicial",
        //   sortable: true
        // },
        {
          key: "total_letter",
          name: "Cartas",
          label: "Cartas",
          sortable: true,
        },
        // {
        //   key: "tracking_call",
        //   name: "Llamada de seguimiento",
        //   label: "Llamada seg.",
        //   sortable: true
        // },
        { key: "total_email", name: "Email", label: "Email", sortable: true },
        {
          key: "total_observation",
          name: "Observación",
          label: "Observación",
          sortable: true,
        },
        {
          key: "total_whatsapp",
          name: "Whatsapp",
          label: "Whatsapp",
          sortable: true,
        },
        {
          key: "total_message",
          name: "Mensaje",
          label: "Mensaje",
          sortable: true,
        },

        // { key: "minutes", name: "Minutos", label: "Minutos", sortable: true },
        { key: "hour", name: "Horas", label: "Horas", sortable: true },
      ],

      json_fields: {
        Fecha: "date_management",
        "# Llamadas iniciales": "total_call",
        "# Visitas": "visit",
        "# Email": "total_email",
        "# Observaciones": "total_observation",
        "# Whatsapp": "total_whatsapp",
        "# Mensajes": "total_message",
        Horas: "hour",
      },

      items: [],
      selectItems: [],
      lstStaffs: [],
      pagination: {},
      fieldsSelected: [],
      selectVal: {},

      staff_idFilter: null,

      currentPage: 1,
      perPage: 10,

      details: [],
      fields_details: [
        { key: "date", name: "Fecha", label: "Fecha" },
        { key: "type_name", name: "Tipo", label: "Tipo" },
        { key: "minutes", name: "Tiempo", label: "Tiempo" },
        { key: "management", name: "Gestión", label: "Gestión" },
        { key: "debtor_name", name: "Deudor", label: "Deudor" },
        { key: "actions", name: "Ver", label: "Ver" },
      ],
      title: null,
    };
  },
  mounted() {
    this.fieldsSelected = this.fields;

    //LISTADO DE STAFF'S: 43: PREJURIDICO
    this.$http.get(`${this.$urlApi}staffs/type/43?token=${this.token}`).then(
      (response) => {
        this.lstStaffs = response.data.data;
        // console.log(response.data.data);
      },
      (error) => {
        console.log(error);
      }
    );

    var auth = JSON.parse(localStorage.getItem("auth"));
    this.staff_idFilter = this.role_id == 1 || this.role_id == 8 ? null : auth[0].staff_id;

    this.getData();
  },
  methods: {
    filteredItems() {
      return this.items.filter((item) => {
        let keep = true;

        // This is a basic equality filter. What I did in the actual code was to have an object with filter functions for each key. If a key was missing, it defaulted to straight equality.
        this.fieldKeys().forEach((key) => {
          keep =
            keep &&
            (this.selectVal[key] === undefined ||
              item[key] === this.selectVal[key]);
        });
        return keep;
      });
    },
    fieldKeys() {
      let keys = [
        "status",
        "advance_name",
        "advance_level_name",
        "initial_call",
        "send_presentation",
        "tracking_call",
        "visit",
        "contract",
        "wallet",
      ];
      return keys;
      // if(this.items[0] === undefined) return null
      // else return Object.keys(this.items[0]);
    },
    options() {
      // This could be simplified if the select was it's own component.
      const options = {};
      //console.log(this.fieldKeys())
      this.fieldKeys().forEach((key) => {
        const vals = this.items.map((item) => item[key]);
        // Cheap and efficient unique.
        options[key] = Array.from(new Set(vals));
      });

      return options;
    },

    changeDate() {
      if (this.range.startDate != "" && this.range.endDate != "") {
        this.getData();
      } else return;
    },
    getData: function () {
      // alert(1);
      let auth = JSON.parse(localStorage.getItem("auth"));

      // if (!this.isAdmin && auth.length > 0) {
      //   this.staff_idFilter = auth[0].staff_id;
      // }

      // console.log(this.staff_idFilter);

      // if (!this.staff_idFilter) return;

      // if (this.staff_idFilter) {
        showLoader();
        let start_date = moment(this.range.startDate).format("YYYY-MM-DD");
        let end_date = moment(this.range.endDate).format("YYYY-MM-DD");

        // let auth = JSON.parse(localStorage.getItem("auth"));

        // if (!this.isAdmin && auth.length > 0) {
        //   this.staff_idFilter = auth[0].staff_id;
        // }

        // ARMAR LA URL CON LA PAGINACIÓN
        // let url = `${this.$urlApi}customers/filterindicators?token=${this.token}`
        let url = `${this.$urlApi}taskmanagements/debtor/analisys/${this.staff_idFilter}/${start_date}/${end_date}?token=${this.token}`;

        this.$http
          .get(url, { headers: { "Content-Type": "application/json" } })
          .then(
            function (response) {
              console.log("response ------------------------------->", response.data.data);
              this.items = response.data.data;
              hideLoader();
            },
            (error) => {
              console.log(error);
              hideLoader();
            }
          );
      // }
    },

    startDownload() {
      showLoader();
    },
    finishDownload() {
      hideLoader();
    },
    totalCall() {
      return this.filteredItems().reduce((accum, item) => {
        return accum + parseInt(item.total_call);
      }, 0);
    },
    totalLetter() {
      return this.filteredItems().reduce((accum, item) => {
        return accum + parseInt(item.total_letter);
      }, 0);
    },
    totalEmail() {
      return this.filteredItems().reduce((accum, item) => {
        return accum + parseFloat(item.total_email);
      }, 0.0);
    },
    totalObservation() {
      return this.filteredItems().reduce((accum, item) => {
        return accum + parseFloat(item.total_observation);
      }, 0.0);
    },
    totalWhatsapp() {
      return this.filteredItems().reduce((accum, item) => {
        return accum + parseFloat(item.total_whatsapp);
      }, 0.0);
    },
    totalMessage() {
      return this.filteredItems().reduce((accum, item) => {
        return accum + parseFloat(item.total_message);
      }, 0.0);
    },
    totalHour() {
      return this.filteredItems().reduce((accum, item) => {
        return accum + parseFloat(item.hour);
      }, 0.0);
    },
    showDetail(item, opt) {
      showLoader();
      this.details = [];
      this.title = null;
      let type_search = "debtor";

      switch (opt) {
        case "total_call":
          this.title = "LLAMADAS";
          break;
        case "total_visit":
          this.title = "VISITAS";
          break;
        case "total_letter":
          this.title = "CARTAS";
          break;
        case "total_email":
          this.title = "CORREOS";
          break;
        case "total_observation":
          this.title = "OBSERVACIONES";
          break;
        case "total_whatsapp":
          this.title = "WHATSAPP";
          break;
        case "total_message":
          this.title = "MENSAJES";
          break;

        default:
          break;
      }

      let url = `${this.$urlApi}taskmanagements/datetype/${item._date_management}/${opt}/${type_search}/${this.staff_idFilter}?token=${this.token}`;

      this.$http
        .get(url, { headers: { "Content-Type": "application/json" } })
        .then(
          function (response) {
            // console.log(response.data.data);
            this.details = response.data.data;
            hideLoader();
          },
          (error) => {
            console.log(error);
            hideLoader();
          }
        );

      $("#dlgDetail").modal({ backdrop: "static", keyboard: false }); // EVITA QUE SE CIERRE EL MODAL AL DAR CLIC FUERA DE EL
      $("#dlgDetail").modal("show");
    },
    closeDetail() {
      $("#dlgDetail").modal("hide");
    },
    viewDebtor(debtor_id) {
      // $("#dlgDetail").modal("hide");
      let url = `${location.origin}/#/debtors/view/${debtor_id.toString()}`;
      window.open(url, "_blank");
      // this.$router.push({
      //   path: `../../debtors/view/${debtor_id.toString()}`
      // });
    },
    sortDate(a, b, key) {
      if (key === "date_management") {
        var aDate = moment(a[key], "DD/MM/YYYY");
        var bDate = moment(b[key], "DD/MM/YYYY");

        if (aDate.isValid && bDate.isValid) {
          if (aDate < bDate) {
            return -1;
          } else if (aDate > bDate) {
            return 1;
          } else {
            return 0;
          }
        }
        return null;
      }
    },
  },
};
</script>
